import axios from "axios";

const getTransferencias = async () => {
  try {
    // Obtener transferencias del localStorage
    const transferenciasGuardadas = localStorage.getItem("transferencias");
    const totalGuardado = localStorage.getItem("totalTransferencias");

    if (transferenciasGuardadas && totalGuardado) {
      return {
        listadoTransferencias: JSON.parse(transferenciasGuardadas),
        totalTrans: parseFloat(totalGuardado),
      };
    } else {
      // Si no hay transferencias guardadas, inicializar con datos por defecto
      const transferenciasIniciales = [
        "94417-08/07 10:38 de CLOVER a caja de tesorería; Efvo: $ 150,000.00; Chqs: $ 0.00.",
        "94418-08/07 10:39 de CLOVER a caja de tesorería; Efvo: $ 90,500.00; Chqs: $ 0.00.",
        "94419-08/07 10:39 de caja de tesorería a CLOVER; Efvo: $ 260,500.00; Chqs: $ 0.00.",
        "94420-08/07 10:40 de CLOVER a entidad recaudadora; Efvo: $ 100,000.00; Chqs: $ 0.00.",
      ];
      const totalInicial = 80000;

      localStorage.setItem("transferencias", JSON.stringify(transferenciasIniciales));
      localStorage.setItem("totalTransferencias", totalInicial.toString());

      return {
        listadoTransferencias: transferenciasIniciales,
        totalTrans: totalInicial,
      };
    }
  } catch (error) {
    console.error("Error al obtener transferencias del localStorage:", error);
    return {
      listadoTransferencias: [],
      totalTrans: 0,
    };
  }
};

const realizarTransferencia = async (IdEmpleado, Efectivo, TipoTransferencia, NumeroSobre) => {
  try {
    // Simular delay del endpoint
    await new Promise(resolve => setTimeout(resolve, 1000));

    // Obtener datos necesarios
    const puesto = JSON.parse(localStorage.getItem("puesto"));
    const nombreCaja = puesto?.nombre || "CAJA";
    const currentDate = new Date();
    const fechaFormateada = currentDate.toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit" });
    const horaFormateada = currentDate.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" });

    // Generar número de comprobante único
    const numeroComprobante = `OTR-0001-${Date.now().toString().slice(-8)}`;

    // Determinar tipo de transferencia y dirección
    let descripcionTransferencia = "";
    let multiplicador = 1; // 1 para sumar, -1 para restar

    switch (TipoTransferencia) {
      case 1: // Entregado a tesorería
        descripcionTransferencia = `${numeroComprobante}-${fechaFormateada} ${horaFormateada} de ${nombreCaja} a caja de tesorería; Efvo: $ ${Efectivo.toLocaleString(
          "es-AR",
          { minimumFractionDigits: 2 },
        )}; Chqs: $ 0.00.`;
        multiplicador = 1; // Suma al total
        break;
      case 2: // Recibido de tesorería
        descripcionTransferencia = `${numeroComprobante}-${fechaFormateada} ${horaFormateada} de caja de tesorería a ${nombreCaja}; Efvo: $ ${Efectivo.toLocaleString(
          "es-AR",
          { minimumFractionDigits: 2 },
        )}; Chqs: $ 0.00.`;
        multiplicador = -1; // Resta del total
        break;
      case 3: // Entregado a empresa recaudadora
        descripcionTransferencia = `${numeroComprobante}-${fechaFormateada} ${horaFormateada} de ${nombreCaja} a entidad recaudadora; Efvo: $ ${Efectivo.toLocaleString(
          "es-AR",
          { minimumFractionDigits: 2 },
        )}; Chqs: $ 0.00. Sobre: ${NumeroSobre}`;
        multiplicador = 1; // Suma al total
        break;
      default:
        throw new Error("Tipo de transferencia no válido");
    }

    // Obtener transferencias y total actual
    const transferenciasActuales = JSON.parse(localStorage.getItem("transferencias")) || [];
    const totalActual = parseFloat(localStorage.getItem("totalTransferencias")) || 0;

    // Agregar nueva transferencia
    transferenciasActuales.push(descripcionTransferencia);

    // Calcular nuevo total
    const nuevoTotal = totalActual + Efectivo * multiplicador;

    // Guardar en localStorage
    localStorage.setItem("transferencias", JSON.stringify(transferenciasActuales));
    localStorage.setItem("totalTransferencias", nuevoTotal.toString());

    return {
      status: 200,
      data: numeroComprobante,
    };
  } catch (error) {
    console.error("Error al realizar la transferencia:", error);
    throw error;
  }
};

const transferencias = {
  getTransferencias,
  realizarTransferencia,
};

export default transferencias;
